<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>委托订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="position: static;float: left">
        <label style="color: orange">委托ID：</label>
        <el-input
            placeholder=""
            clearable
            v-model="queryData.orderId"
        >
        </el-input>
        <label style="color: orange">账户ID：</label>
        <el-input
            placeholder=""
            clearable
            v-model="queryData.uid"
        >
        </el-input>
        <label style="color: orange">交易对：</label>
        <el-select :value="queryData.pair" @change="setPair" placeholder="请选择">
          <el-option
              v-for="item in pairs"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
        <label style="color: orange">交易ID：</label>
        <el-input
            placeholder=""
            clearable
            v-model="queryData.tid"
        >
        </el-input>
        <label>方向：</label>
        <el-select :value="queryData.direction" @change="setQueryType3" placeholder="请选择">
          <el-option
              v-for="item in queryType3"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>

        <el-date-picker
            type="datetimerange"
            value-format="timestamp"
            v-model="timeRange"
            start-placeholder="起始时间"
            end-placeholder="终止时间"
        >
        </el-date-picker>
        <label>是否有手续费：</label>
        <el-select :value="queryData.fee" @change="setQueryType4" placeholder="请选择">
          <el-option
              v-for="item in queryType4"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-button
            type="primary"
            @click="handleSearch"
        >搜索
        </el-button>
        <el-button
            type=""
            @click="reset"
        >重置
        </el-button>

      </div>
      <div style="color: red">
        * 请填写黄色筛选条件中的任意一个条件，不填写筛选条件将无法正常筛选
      </div>

      <el-table :data="list" ref="multipleTable">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="交易ID"></el-table-column>
        <el-table-column prop="userId" label="账户ID">
          <template slot-scope="scope">
            {{ scope.row.dealDirection === "B" ? scope.row.buyerId : scope.row.sellerId }}
          </template>
        </el-table-column>
        <el-table-column prop="id" label="委托ID">
          <template slot-scope="scope">
            {{ scope.row.dealDirection === "B" ? scope.row.refBuyOrder : scope.row.refSellOrder }}
          </template>
        </el-table-column>
        <el-table-column label="交易对手账户ID">
          <template slot-scope="scope">
            {{ scope.row.dealDirection === "B" ? scope.row.sellerId : scope.row.buyerId }}
          </template>
        </el-table-column>

        <el-table-column label="交易对手委托ID">
          <template slot-scope="scope">
            {{ scope.row.dealDirection === "B" ? scope.row.refSellOrder : scope.row.refBuyOrder }}
          </template>
        </el-table-column>

        <el-table-column prop="pair" label="交易对"/>
        <el-table-column prop="direction" label="方向">
          <template slot-scope="scope">
            {{ scope.row.dealDirection === "B" ? "买入" : "卖出" }}
          </template>
        </el-table-column>
        <el-table-column prop="price" label="成交价格">
        </el-table-column>
        <el-table-column prop="dealVolume" label="成交数量">
        </el-table-column>
        <el-table-column label="成交金额" prop="dealAmount">
        </el-table-column>
        <el-table-column label="手续费">
          <template slot-scope="scope">
            {{ scope.row.dealDirection === "B" ? scope.row.buyerFee : scope.row.sellerFee }}
          </template>
        </el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="queryData.size"
                     :current-page="queryData.page" @current-change="changePage"/>
    </el-card>
  </div>
</template>

<script>
import '../store';
import api from '../api';

export default {
  name: 'orderDetail',
  props: {dataList: Array, pair: String},
  data() {
    return {
      list: [],
      pairs: [],
      total: 0,
      queryType2: [{label: "限价", value: "LIMIT"}, {label: "市价", value: "MARKET"}],
      queryType3: [{label: "买入", value: "B"}, {label: "卖出", value: "S"}],
      queryType4: [{label: "有", value: 1}, {label: "无", value: 0}],
      timeRange: [new Date().getTime() - 24 * 90 * 60 * 60 * 1000, new Date().getTime()],
      queryData: {
        uid: "",
        fee: null,
        orderId: "",
        tid: "",
        from: null,
        to: null,
        direction: "",
        state: null,
        pair: "",
        size: 10,
        page: 1
      }
    };
  },
  methods: {
    changePage: function (currentPage) {
      this.queryData.page = currentPage;
      this.handleSearch();
    },
    setPair: function (select) {
      this.queryData.pair = select;
    },
    setQueryType2: function (select) {
      this.queryData.type = select;
    },
    setQueryType3: function (select) {
      this.queryData.direction = select;
    },
    setQueryType4: function (select) {
      this.queryData.fee = select;
    },
    handleSearch: function () {

      if (!this.queryData.orderId && !this.queryData.uid && !this.queryData.pair) {
        this.$message.error("请填写黄色筛选条件中的任意一个条件，不填写筛选条件将无法正常筛选");
        return;
      }

      if (this.timeRange === null) {
        this.$message("查询时间不能为空")
        return;
      }

      if (this.timeRange[0] >= this.timeRange[1]) {
        this.$message('开始时间需小于等于截止时间');
        return;
      }


      if (this.timeRange[1] > new Date().getTime()) {
        this.$message('截止时间 不能大于当前时间');
        return;
      }

      this.queryData.from = this.timeRange[0];
      this.queryData.to = this.timeRange[1];


      api.getDetails(this.queryData).then(response => {
        if (response.code == 0) {
          this.list = response.data.data;
          this.total = response.data.total;

          console.log(this.total)
        } else {
          alert("查询失败");
        }
      });

    },
    getStatus: function (status) {
      switch (status) {
        case 0:
          return "NORMAL";
        case 1:
          return "完全成交";
        case 2:
          return "已撤销";
        case 3:
          return "部分成交";
        default:
          return "";
      }
    },
    cancelOrder: function () {
      alert('历史委托无法撤单');
    },
    reset: function () {
      this.list = [];
      this.queryData = {
        uid: "",
        fee: null,
        orderId: "",
        tid: "",
        from: null,
        to: null,
        direction: "",
        state: null,
        pair: "",
        size: 10,
        page: 1
      };
    }


  },
  created() {
    api.getAllPair().then(response => {
      if (response.code == 0) {
        this.pairs = response.data;
      } else {
      }
    })
  }
};
</script>


